var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useState } from "react";
import MutualFundOrders from "./MutualFundOrders";
import { EMutualFundOrderTabs, } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IMutualFundTransactionsCommonEntity";
import SearchPanelWithPopupFiltersLabel from "@frameworks/shared-library/components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
import ExcelPdfDownload from "../common/ExcelPdfDownload/ExcelPdfDownload";
import MFOrderbookCalendarFilter from "../common/MFOrderbookCalendarFilter/MFOrderbookCalendarFilter";
import SummaryFilters from "../common/SummaryFilters/SummaryFilters";
import _ from "underscore";
import "@frameworks/salesjourney/stylesheets/components/Features/ActivityBook/RM_Orderbook/RM_Orderbook.scss";
import mutualFunOrderbookDi from "@mainDi/features/ActivityBook/OrderBook/MutualFund/servicelocator";
import { useSelector } from "react-redux";
import { allTransactionInitialData } from "@redux/feature/ActivityBook/OrderBook/MutualFund/Reducers/MutualFundAllTransactionsReducers";
import { SIP_STP_SWP_InitialData } from "@redux/feature/ActivityBook/OrderBook/MutualFund/Reducers/MutualFundSIP_STP_SWP_TransactionsReducers";
import { accountDetails } from "@mainDi/salesDi";
import debounce from "@frameworks/web/utils/debounce";
import { useLocation } from "react-router-dom";
import { EFilterType } from "@domains/utils/filter";
import ClientNamesWithHorizontalClientCodes from "../common/ClientNamesWithHorizontalClientCodes/ClientNamesWithHorizontalClientCodes";
import { useNavigate } from "react-router-dom";
import { ProductOrderContext } from "../ProductOrders/ProductOrdersContext";
import { ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import ProductOrderBook from "@frameworks/pmsjourney/app/ProductOrderBook";
import moment from "moment";
import TransferInFilters from "./MutualFundOrders/TransferIn/TransferInFilters";
import OtcProductOrder from "@frameworks/NCD/pages/OrderBook/StructuredProducts";
import { checkIfOtcIsAccessible } from "../../../../../utils/genericMethods";
export var leadRedirectionState = {
    orderId: "",
    orderDate: "",
    productCode: "",
    categoryCode: "",
};
var ManagePortfolio = function (props) {
    var _a, _b, _c, _d, _e;
    var location = useLocation();
    var navigate = useNavigate();
    var params = new URLSearchParams(location.search);
    leadRedirectionState.orderId = params.get("orderId");
    leadRedirectionState.categoryCode = params.get("categoryCode");
    leadRedirectionState.productCode = params.get("productCode");
    leadRedirectionState.productType = Number(params.get("productType"));
    // *******************************************
    // *           Contexts                  *
    // *******************************************
    var productOrdersContext = useContext(ProductOrderContext);
    // *******************************************
    // *           useStates                     *
    // *******************************************
    var _f = __read(React.useState(false), 2), isShowFilterPopup = _f[0], setIsShowFilterPopup = _f[1];
    var _g = __read(React.useState([]), 2), summaryFilterLabels = _g[0], setSummaryFilterLabels = _g[1];
    var _h = __read(React.useState(undefined), 2), allTransactionsFilters = _h[0], setAllTransactionsFilters = _h[1];
    var _j = __read(React.useState(undefined), 2), SIP_STP_SWP_Filters = _j[0], setSIP_STP_SWP_Filters = _j[1];
    var _k = __read(React.useState(""), 2), searchValue = _k[0], setSearchValue = _k[1];
    var _l = __read(React.useState(false), 2), excelDownloadLoader = _l[0], setExcelDownloadLoader = _l[1];
    var _m = __read(React.useState(false), 2), isShowExportPopup = _m[0], setIsShowExportPopup = _m[1];
    var _o = __read(React.useState({
        filteredData: undefined,
        searchText: "",
    }), 2), mandatesFilters = _o[0], setMandatesFilters = _o[1];
    var _p = __read(useState(true), 2), isOtcAccessible = _p[0], setIsOtcAccessible = _p[1];
    // *******************************************
    // *           useSelectors                 *
    // *******************************************
    var currentSelectedMutualFundTransactionsTab = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions
            .mutualFundTransactionsCommonReducer.currentSelectedTransactionTab;
    });
    var commonDataFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions.mutualFundTransactionsCommonReducer;
    });
    var metaAllTransactionDataFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions
            .mutualFundsAllTransactionsReducer;
    }, _.isEqual);
    var metaSIP_STP_SWP_DataFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions
            .mutualFundsSIP_STP_SWP_TransactionsReducer;
    }, _.isEqual);
    var mandateDataFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions
            .mutualFundsMandateTransactionsReducer;
    }, _.isEqual);
    var transferInDataFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions.mutualFundsTransferInReducer;
    }, _.isEqual);
    // *******************************************
    // *           API FUNCTIONS                 *
    // *******************************************
    var getAllTransactionsData = function (latestFiltersData) {
        if (latestFiltersData === void 0) { latestFiltersData = allTransactionsFilters; }
        return __awaiter(void 0, void 0, void 0, function () {
            var loginCode, loginType, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // calling of the orderbook api for leadRedirectionState is already handled in MutualFundOders index component
                        if (leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!!productOrdersContext.detailedViewEnabled) return [3 /*break*/, 5];
                        return [4 /*yield*/, accountDetails.getUserLoginCode()];
                    case 2:
                        loginCode = _a.sent();
                        return [4 /*yield*/, accountDetails.getUserLoginType()];
                    case 3:
                        loginType = _a.sent();
                        return [4 /*yield*/, mutualFunOrderbookDi.mutualFundOrderBook.getMutualFundOrderBook(__assign({ loginType: loginType, loginCode: loginCode }, latestFiltersData))];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    var getSIP_STP_STP_Data = function (reqPayload) {
        if (reqPayload === void 0) { reqPayload = SIP_STP_SWP_Filters; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, err_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        if (!!productOrdersContext.detailedViewEnabled) return [3 /*break*/, 4];
                        _a = reqPayload;
                        return [4 /*yield*/, accountDetails.getUserLoginCode()];
                    case 1:
                        _a.loginCode = _c.sent();
                        _b = reqPayload;
                        return [4 /*yield*/, accountDetails.getUserLoginType()];
                    case 2:
                        _b.loginType = _c.sent();
                        return [4 /*yield*/, mutualFunOrderbookDi.mutualFundOrderBook.getMFOrderbookSummary(reqPayload)];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_2 = _c.sent();
                        console.log(err_2);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    var getOrderbookTransferInTableData = function (params) {
        var _a, _b, _c, _d;
        var payload = {
            searchValue: (_a = params === null || params === void 0 ? void 0 : params.searchValue) !== null && _a !== void 0 ? _a : "",
            tabId: 0,
            clientTierId: "",
            investmentValueId: "",
            orderstatusId: (_b = params === null || params === void 0 ? void 0 : params.orderstatusId) !== null && _b !== void 0 ? _b : "",
            sync_id: 0,
            uccCode: "",
            page_index: 1,
            page_size: 10,
            orderbydesc: true,
            orderby: "",
            fromdate: (_c = params === null || params === void 0 ? void 0 : params.fromdate) !== null && _c !== void 0 ? _c : "2025-06-01",
            todate: (_d = params === null || params === void 0 ? void 0 : params.todate) !== null && _d !== void 0 ? _d : moment().format("YYYY-MM-DD"),
        };
        mutualFunOrderbookDi.mutualFundOrderBook.getTransferInTabData(payload);
    };
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    var handleUpdateSummaryFilters = function (data) {
        switch (currentSelectedMutualFundTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                setAllTransactionsFilters(function () { return data; });
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                setSIP_STP_SWP_Filters(function () { return data; });
                break;
            case EMutualFundOrderTabs.MANDATES:
                break;
            case EMutualFundOrderTabs.TRANSFER_IN:
                break;
        }
    };
    var handleApplyFilters = function (latestFiltersData, allData) {
        handleUpdateFilterPopupState(false);
        handleClearRedirectionParamsAndObject();
        switch (currentSelectedMutualFundTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                if (!(leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId)) {
                    delete latestFiltersData.trxId;
                }
                mutualFunOrderbookDi.mutualFundOrderBook.updateAllTransactionsFilters(latestFiltersData);
                handleCreateLabelsForAppliedFiltersForAllTransactions(latestFiltersData, allData);
                getAllTransactionsData(latestFiltersData);
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                mutualFunOrderbookDi.mutualFundOrderBook.updateSIP_STP_SWP_Filters(latestFiltersData);
                getSIP_STP_STP_Data(latestFiltersData);
                handleCreateLabelsForAppliedFiltersForSIP_SWP_STP_Transactions(latestFiltersData, allData);
                break;
        }
    };
    var handleRemoveSummaryFilterThroughLabels = function (value, 
    // keyName: keyof IGetMutualFundOrderBookPayload
    keyName) {
        switch (currentSelectedMutualFundTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                handleRemoveAllTransactionsFiltersThroughLabels(value, keyName);
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                handleRemoveSIP_STP_SWP_FiltersThroughLabels(value, keyName);
                break;
        }
    };
    var handleRemoveAllTransactionsFiltersThroughLabels = function (value, keyName) {
        var updatedLabels = summaryFilterLabels.filter(function (item) { return item.value !== value; });
        var updatedFilters = __assign({}, metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters);
        if (Array.isArray(updatedFilters[keyName])) {
            if (value === "All") {
                updatedFilters[keyName] = [];
            }
            else {
                updatedFilters[keyName] = updatedFilters[keyName].filter(function (item) { return item !== value; });
            }
        }
        handleUpdateSummaryFilterLabelsData(updatedLabels);
        mutualFunOrderbookDi.mutualFundOrderBook.updateAllTransactionsFilters(updatedFilters);
        getAllTransactionsData(updatedFilters);
    };
    var handleRemoveSIP_STP_SWP_FiltersThroughLabels = function (value, keyName
    // filterData = SIP_STP_SWP_TransactionsFilter
    ) {
        var updatedLabels = summaryFilterLabels.filter(function (item) { return item.value !== value; });
        var updatedFilters = __assign({}, metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters);
        if (Array.isArray(updatedFilters[keyName])) {
            if (value === "All") {
                updatedFilters[keyName] = [];
            }
            else {
                updatedFilters[keyName] = updatedFilters[keyName].filter(function (item) { return item !== value; });
            }
        }
        mutualFunOrderbookDi.mutualFundOrderBook.updateSIP_STP_SWP_Filters(updatedFilters);
        handleUpdateSummaryFilterLabelsData(updatedLabels);
        // handleUpdateSIP_STP_SWP_Filter(updatedFilters);
        getSIP_STP_STP_Data(__assign({}, updatedFilters));
    };
    var handleCancelFilters = function () {
        switch (currentSelectedMutualFundTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                handleUpdateSummaryFilters(JSON.parse(JSON.stringify(metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters)));
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                handleUpdateSummaryFilters(JSON.parse(JSON.stringify(metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters)));
                break;
            case EMutualFundOrderTabs.MANDATES:
                handleUpdateMandateFilterData(mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters);
                break;
        }
        setIsShowFilterPopup(false);
    };
    var handleClearAllFilters = function () {
        switch (currentSelectedMutualFundTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                mutualFunOrderbookDi.mutualFundOrderBook.clearAllTransactionsFilters();
                handleApplyFilters(__assign(__assign({}, allTransactionInitialData === null || allTransactionInitialData === void 0 ? void 0 : allTransactionInitialData.appliedFilters), { fromDate: allTransactionsFilters.fromDate, toDate: allTransactionsFilters.toDate, searchText: allTransactionsFilters.searchText }));
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                mutualFunOrderbookDi.mutualFundOrderBook.clearSIP_STP_SWP_Filters();
                handleApplyFilters(__assign(__assign({}, SIP_STP_SWP_InitialData === null || SIP_STP_SWP_InitialData === void 0 ? void 0 : SIP_STP_SWP_InitialData.appliedFilters), { toDate: SIP_STP_SWP_Filters.toDate, fromDate: SIP_STP_SWP_Filters.fromDate, searchText: SIP_STP_SWP_Filters.searchText }));
                break;
            case EMutualFundOrderTabs.MANDATES:
                handleUpdateMandateFilterData({
                    searchText: mandateDataFromRedux.appliedFilters.searchText,
                    filteredData: {
                        dpDate: __assign({}, mandateDataFromRedux.appliedFilters.filteredData.dpDate),
                    },
                });
                handleUpdateSummaryFilterLabelsData([]);
                mutualFunOrderbookDi.mutualFundOrderBook.clearMandateFilters();
                break;
        }
        setIsShowFilterPopup(false);
    };
    var handleSearchFunds = React.useCallback(function (text) {
        setSearchValue(text);
        handleClearRedirectionParamsAndObject();
        switch (currentSelectedMutualFundTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                {
                    var localFilterData_1 = __assign(__assign({}, metaAllTransactionDataFromRedux.appliedFilters), { searchText: text });
                    if (!(leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId)) {
                        delete localFilterData_1.trxId;
                    }
                    mutualFunOrderbookDi.mutualFundOrderBook.updateAllTransactionsFilters(localFilterData_1);
                    debounce(function () {
                        return getAllTransactionsData(__assign({}, localFilterData_1));
                    }, 300)();
                }
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                {
                    var localFilterData_2 = __assign(__assign({}, metaSIP_STP_SWP_DataFromRedux.appliedFilters), { searchText: text });
                    mutualFunOrderbookDi.mutualFundOrderBook.updateSIP_STP_SWP_Filters(localFilterData_2);
                    debounce(function () {
                        return getSIP_STP_STP_Data(__assign({}, localFilterData_2));
                    }, 300)();
                }
                break;
            case EMutualFundOrderTabs.MANDATES:
                handleSearchMandates(text);
            case EMutualFundOrderTabs.TRANSFER_IN:
                debounce(function () { return getOrderbookTransferInTableData({ searchValue: text }); }, 400)();
                break;
        }
    }, [
        currentSelectedMutualFundTransactionsTab,
        metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters,
        metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters,
        commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM,
        mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters,
        mandatesFilters,
    ]);
    var handleDownloadExcel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, loginCode, loginType, isDownloadSuccessful, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setExcelDownloadLoader(true);
                    payload = undefined;
                    switch (currentSelectedMutualFundTransactionsTab) {
                        case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                            payload = __assign({}, metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters);
                            delete payload.txnType;
                            break;
                        case EMutualFundOrderTabs.SIPs:
                        case EMutualFundOrderTabs.STPs:
                        case EMutualFundOrderTabs.SWPs:
                            payload = __assign({}, metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters);
                            break;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 2:
                    loginCode = _a.sent();
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 3:
                    loginType = _a.sent();
                    return [4 /*yield*/, mutualFunOrderbookDi.mutualFundOrderBook.downloadMFOrderBookExcelFile(__assign({ loginType: loginType, loginCode: loginCode }, payload))];
                case 4:
                    isDownloadSuccessful = _a.sent();
                    // update error messages later
                    if (isDownloadSuccessful) {
                        productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                            isShow: true,
                            isError: false,
                            msg: "Excel file downloaded successfully!",
                        });
                    }
                    else {
                        productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                            isShow: true,
                            isError: true,
                            msg: "Failed to download excel file!",
                        });
                    }
                    setExcelDownloadLoader(false);
                    return [3 /*break*/, 6];
                case 5:
                    err_3 = _a.sent();
                    // update state for technical error once state received from design team
                    setExcelDownloadLoader(false);
                    console.log(err_3);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateSummaryFilterLabelsData = function (data) {
        setSummaryFilterLabels(function () { return data; });
    };
    var handleUpdateFilterPopupState = function (data) {
        setIsShowFilterPopup(data);
    };
    var handleUpdateMandateFilterData = function (data) {
        setMandatesFilters(__assign({}, data));
    };
    var handleApplyMandateFilters = function (data) {
        mutualFunOrderbookDi.mutualFundOrderBook.updateAndApplyMandateFilters(__assign(__assign({}, mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters), { filteredData: __assign({}, data) }));
        handleCreateMandateFilterLabels(data);
        setIsShowFilterPopup(false);
    };
    var handleRemoveMandateFiltersThroughLabels = function (value, keyName, subKeyName) {
        var localMandatesFilters = __assign({}, mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData);
        var firstLevelData = localMandatesFilters[keyName];
        if (firstLevelData[subKeyName].subListFiltersValues) {
            delete firstLevelData[subKeyName].subListFiltersValues[value];
            if (!Object.keys(firstLevelData[subKeyName].subListFiltersValues).length) {
                delete firstLevelData[subKeyName];
                if (!Object.keys(firstLevelData).length) {
                    delete localMandatesFilters[keyName];
                }
            }
        }
        else {
            delete firstLevelData[subKeyName];
        }
        var localFilterLabels = summaryFilterLabels.filter(function (item) { return item.value !== value; });
        mutualFunOrderbookDi.mutualFundOrderBook.updateAndApplyMandateFilters(__assign(__assign({}, mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters), { filteredData: localMandatesFilters }));
        handleUpdateSummaryFilterLabelsData(localFilterLabels);
    };
    var handleCreateMandateFilterLabels = function (data) {
        var _a;
        var localFilterLabels = [];
        if (!data)
            return;
        (_a = Object.keys(data)) === null || _a === void 0 ? void 0 : _a.forEach(function (level1Key) {
            Object.keys(data[level1Key]).forEach(function (level2Key) {
                var parentFilter = data[level1Key];
                if (parentFilter[level2Key].type !== EFilterType.Date &&
                    parentFilter[level2Key].filterValue) {
                    if (parentFilter[level2Key].subListFiltersValues) {
                        Object.keys(parentFilter[level2Key].subListFiltersValues).forEach(function (subFilterKey) {
                            var _a;
                            localFilterLabels.push({
                                title: (React.createElement("div", null, (_a = parentFilter[level2Key]) === null || _a === void 0 ? void 0 :
                                    _a.displayValue,
                                    ":\u00A0",
                                    parentFilter[level2Key].subListFiltersValues[subFilterKey].filterValue)),
                                disable: false,
                                value: parentFilter[level2Key].subListFiltersValues[subFilterKey]
                                    .filterValue,
                                keyName: level1Key,
                                subKeyName: level2Key,
                            });
                        });
                    }
                    else {
                        localFilterLabels.push({
                            title: React.createElement("div", null, parentFilter[level2Key].filterValue),
                            disable: false,
                            value: parentFilter[level2Key].filterValue,
                            keyName: level1Key,
                            subKeyName: level2Key,
                        });
                    }
                }
            });
        });
        handleUpdateSummaryFilterLabelsData(localFilterLabels);
    };
    var handleSearchMandates = function (searchString) {
        setMandatesFilters(__assign(__assign({}, mandatesFilters), { searchText: searchString }));
        debounce(function () {
            mutualFunOrderbookDi.mutualFundOrderBook.updateAndApplyMandateFilters(__assign(__assign({}, mandatesFilters), { searchText: searchString }));
        }, 300)();
    };
    var handleCreateLabelsForAppliedFiltersForAllTransactions = function (filterData, allData) {
        var _a, _b, _c, _d, _e, _f;
        if (filterData === void 0) { filterData = metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters; }
        if (allData === void 0) { allData = {
            transactionsStatusData: (_b = (_a = metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.allTransactionsData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.tranSummaryList,
            clientsData: commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM,
        }; }
        var localFilterLabels = [];
        if (filterData === null || filterData === void 0 ? void 0 : filterData.clientCodes) {
            var selectedClients = (_c = allData === null || allData === void 0 ? void 0 : allData.clientsData) === null || _c === void 0 ? void 0 : _c.filter(function (item) {
                return filterData.clientCodes.includes(item.accountCode);
            });
            selectedClients === null || selectedClients === void 0 ? void 0 : selectedClients.forEach(function (client) {
                localFilterLabels.push({
                    title: (React.createElement(ClientNamesWithHorizontalClientCodes, { clientCode: client.accountCode, clientName: client.clientName, clientType: "Client" })),
                    disable: false,
                    value: client.accountCode,
                    keyName: "clientCodes",
                    subKeyName: client.clientName,
                });
            });
        }
        if (filterData === null || filterData === void 0 ? void 0 : filterData.status) {
            if (((_d = allData === null || allData === void 0 ? void 0 : allData.transactionsStatusData) === null || _d === void 0 ? void 0 : _d.length) === ((_e = filterData === null || filterData === void 0 ? void 0 : filterData.status) === null || _e === void 0 ? void 0 : _e.length)) {
                localFilterLabels.push({
                    title: (React.createElement("div", { className: "d-flex align-items-center gap-10" }, "Order Status: All")),
                    disable: false,
                    value: "All",
                    keyName: "status",
                    subKeyName: "All",
                });
            }
            else {
                var selectedStatuses = (_f = allData === null || allData === void 0 ? void 0 : allData.transactionsStatusData) === null || _f === void 0 ? void 0 : _f.filter(function (item) { return filterData.status.includes(item.status); });
                selectedStatuses === null || selectedStatuses === void 0 ? void 0 : selectedStatuses.forEach(function (status) {
                    localFilterLabels.push({
                        title: (React.createElement("div", { className: "d-flex align-items-center gap-10" },
                            "Order Status: ",
                            status.status)),
                        disable: false,
                        value: status.status,
                        keyName: "status",
                        subKeyName: status.status,
                    });
                });
            }
        }
        handleUpdateSummaryFilterLabelsData(localFilterLabels);
    };
    var handleCreateLabelsForAppliedFiltersForSIP_SWP_STP_Transactions = function (filterData, allData) {
        var _a, _b, _c, _d, _e, _f;
        if (filterData === void 0) { filterData = metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters; }
        if (allData === void 0) { allData = {
            transactionsStatusData: (_b = (_a = metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.SIP_STP_SWP_TransactionsData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.tranSummaryList,
            clientsData: commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM,
        }; }
        var localFilterLabels = [];
        if (filterData === null || filterData === void 0 ? void 0 : filterData.clientCodes) {
            var selectedClients = (_c = allData === null || allData === void 0 ? void 0 : allData.clientsData) === null || _c === void 0 ? void 0 : _c.filter(function (item) {
                return filterData.clientCodes.includes(item.accountCode);
            });
            selectedClients === null || selectedClients === void 0 ? void 0 : selectedClients.forEach(function (client) {
                localFilterLabels.push({
                    title: (React.createElement(ClientNamesWithHorizontalClientCodes, { clientCode: client.accountCode, clientName: client.clientName, clientType: "Client" })),
                    disable: false,
                    value: client.accountCode,
                    keyName: "clientCodes",
                    subKeyName: client.clientName,
                });
            });
        }
        if (filterData === null || filterData === void 0 ? void 0 : filterData.status) {
            if (((_d = allData === null || allData === void 0 ? void 0 : allData.transactionsStatusData) === null || _d === void 0 ? void 0 : _d.length) === ((_e = filterData === null || filterData === void 0 ? void 0 : filterData.status) === null || _e === void 0 ? void 0 : _e.length)) {
                localFilterLabels.push({
                    title: (React.createElement("div", { className: "d-flex align-items-center gap-10" }, "Order Status: All")),
                    disable: false,
                    value: "All",
                    keyName: "status",
                    subKeyName: "All",
                });
            }
            else {
                var selectedStatuses = (_f = allData === null || allData === void 0 ? void 0 : allData.transactionsStatusData) === null || _f === void 0 ? void 0 : _f.filter(function (item) { return filterData.status.includes(item.status); });
                selectedStatuses === null || selectedStatuses === void 0 ? void 0 : selectedStatuses.forEach(function (status) {
                    localFilterLabels.push({
                        title: (React.createElement("div", { className: "d-flex align-items-center gap-10" },
                            "Order Status: ",
                            status.status)),
                        disable: false,
                        value: status.status,
                        keyName: "status",
                        subKeyName: status.status,
                    });
                });
            }
        }
        handleUpdateSummaryFilterLabelsData(localFilterLabels);
    };
    var handleAssignFilterData = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        switch (currentSelectedMutualFundTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                return allTransactionsFilters;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                return SIP_STP_SWP_Filters;
            case EMutualFundOrderTabs.MANDATES:
                return !!mandatesFilters
                    ? __assign(__assign({}, mandatesFilters), (!!((_a = mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) === null || _a === void 0 ? void 0 : _a.dpDate) && {
                        fromDate: (_d = (_c = (_b = mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) === null || _b === void 0 ? void 0 : _b.dpDate) === null || _c === void 0 ? void 0 : _c.fromDate) === null || _d === void 0 ? void 0 : _d.filterValue,
                        toDate: (_g = (_f = (_e = mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) === null || _e === void 0 ? void 0 : _e.dpDate) === null || _f === void 0 ? void 0 : _f.toDate) === null || _g === void 0 ? void 0 : _g.filterValue,
                    })) : __assign(__assign({}, mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters.filteredData), (((_h = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _h === void 0 ? void 0 : _h.filteredData) &&
                    ((_j = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _j === void 0 ? void 0 : _j.filteredData["dpDate"]) && {
                    fromDate: (_l = (_k = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _k === void 0 ? void 0 : _k.filteredData["dpDate"]["fromDate"]) === null || _l === void 0 ? void 0 : _l.filterValue,
                    toDate: (_o = (_m = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _m === void 0 ? void 0 : _m.filteredData["dpDate"]["toDate"]) === null || _o === void 0 ? void 0 : _o.filterValue,
                }));
        }
    };
    var handleApplyMandateCalendarFilters = function (data) {
        var localMandateFilterData = __assign({}, mandatesFilters);
        localMandateFilterData.filteredData.dpDate = {
            fromDate: __assign(__assign({}, localMandateFilterData.filteredData.dpDate.fromDate), { filterValue: data.fromDate }),
            toDate: __assign(__assign({}, localMandateFilterData.filteredData.dpDate.toDate), { filterValue: data.toDate }),
        };
        handleApplyMandateFilters(localMandateFilterData === null || localMandateFilterData === void 0 ? void 0 : localMandateFilterData.filteredData);
    };
    var handleApplyTransferInCalendarFilters = function (data) {
        var _a, _b;
        getOrderbookTransferInTableData({
            fromdate: (_a = data === null || data === void 0 ? void 0 : data.fromDate) !== null && _a !== void 0 ? _a : "",
            todate: (_b = data === null || data === void 0 ? void 0 : data.toDate) !== null && _b !== void 0 ? _b : "",
        });
    };
    var handleClearRedirectionParamsAndObject = function () {
        if (leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId) {
            leadRedirectionState.orderId = "";
            leadRedirectionState.categoryCode = "";
            leadRedirectionState.orderDate = "";
            leadRedirectionState.productCode = "";
            leadRedirectionState.productType = -1;
            navigate(".", { replace: true }); // clearing location state
        }
    };
    var handleUpdateSearchValue = function () {
        var _a, _b;
        switch (currentSelectedMutualFundTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                setSearchValue((_a = metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters) === null || _a === void 0 ? void 0 : _a.searchText);
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                setSearchValue((_b = metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters) === null || _b === void 0 ? void 0 : _b.searchText);
                break;
        }
    };
    // *******************************************
    // *           useEffects                    *
    // *******************************************
    React.useEffect(function () {
        if (currentSelectedMutualFundTransactionsTab ===
            EMutualFundOrderTabs.ALL_TRANSACTIONS) {
            handleUpdateSummaryFilters(JSON.parse(JSON.stringify(metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters)));
            handleCreateLabelsForAppliedFiltersForAllTransactions(metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters);
        }
    }, [
        metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters,
        currentSelectedMutualFundTransactionsTab,
    ]);
    React.useEffect(function () {
        if (currentSelectedMutualFundTransactionsTab !==
            EMutualFundOrderTabs.ALL_TRANSACTIONS) {
            handleUpdateSummaryFilters(JSON.parse(JSON.stringify(metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters)));
            handleCreateLabelsForAppliedFiltersForSIP_SWP_STP_Transactions(metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters);
        }
    }, [
        metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters,
        currentSelectedMutualFundTransactionsTab,
    ]);
    React.useEffect(function () {
        handleUpdateSearchValue();
    }, [
        currentSelectedMutualFundTransactionsTab,
        metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.appliedFilters,
        metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.appliedFilters,
    ]);
    React.useEffect(function () {
        var _a, _b;
        if (currentSelectedMutualFundTransactionsTab ===
            EMutualFundOrderTabs.MANDATES &&
            ((_a = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _a === void 0 ? void 0 : _a.filteredData)) {
            handleUpdateMandateFilterData(JSON.parse(JSON.stringify(mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters)));
            handleCreateMandateFilterLabels((_b = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _b === void 0 ? void 0 : _b.filteredData);
        }
        else {
            handleUpdateSummaryFilterLabelsData([]);
        }
    }, [
        (_a = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _a === void 0 ? void 0 : _a.filteredData,
        currentSelectedMutualFundTransactionsTab,
    ]);
    useEffect(function () {
        if (leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId) {
            setSearchValue(leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId);
        }
    }, [leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId]);
    React.useEffect(function () {
        productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.handleAddCleaningFunction([
            function () {
                return mutualFunOrderbookDi.mutualFundOrderBook.resetAllTransactionsFiltersAndSearch();
            },
            function () {
                return mutualFunOrderbookDi.mutualFundOrderBook.resetSIP_STP_SWP_TransactionsFiltersAndSearch();
            },
            function () {
                return mutualFunOrderbookDi.mutualFundOrderBook.resetMandateFiltersAndSearch();
            },
            function () {
                return mutualFunOrderbookDi.mutualFundOrderBook.updateCurrentSelectedTransactionTab(EMutualFundOrderTabs.ALL_TRANSACTIONS);
            },
        ]);
    }, []);
    useEffect(function () {
        checkIfOtcIsAccessible()
            .then(function (value) {
            setIsOtcAccessible(value);
        })
            .catch(function (e) {
            console.error(e);
            setIsOtcAccessible(true);
        });
    }, []);
    return (React.createElement("div", { className: "d-flex flex-column gap-3 bg_white" },
        !productOrdersContext.detailedViewEnabled && (React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "mb-20", searchBarParentClassName: "w-400", searchValue: currentSelectedMutualFundTransactionsTab ===
                EMutualFundOrderTabs.MANDATES
                ? mandatesFilters.searchText
                : searchValue, autoComplete: "off", clearSearching: function () { }, applySearchedFilters: handleSearchFunds, isShowPopup: isShowFilterPopup, setIsShowPopup: handleUpdateFilterPopupState, placeholder: "Search by fund name, client name, type...", disableDefaultDebounce: true, enableOnChangeFunctionInUseEffect: false, rightSubComponent: React.createElement(React.Fragment, null,
                React.createElement(MFOrderbookCalendarFilter, { filtersData: handleAssignFilterData(), handleFilterChangeCallback: handleUpdateSummaryFilters, handleApplyCallback: currentSelectedMutualFundTransactionsTab ===
                        EMutualFundOrderTabs.MANDATES
                        ? handleApplyMandateCalendarFilters
                        : currentSelectedMutualFundTransactionsTab ===
                            EMutualFundOrderTabs.TRANSFER_IN
                            ? handleApplyTransferInCalendarFilters
                            : handleApplyFilters }),
                !(currentSelectedMutualFundTransactionsTab ===
                    EMutualFundOrderTabs.MANDATES ||
                    currentSelectedMutualFundTransactionsTab ===
                        EMutualFundOrderTabs.TRANSFER_IN) && (React.createElement(ExcelPdfDownload, { excelDownloadLoader: excelDownloadLoader, handleExcelDownloadCallback: handleDownloadExcel, isShowExportPopup: isShowExportPopup, setIsShowExportPopup: setIsShowExportPopup }))), filterComponentInsidePopup: currentSelectedMutualFundTransactionsTab ===
                EMutualFundOrderTabs.TRANSFER_IN ? (React.createElement(TransferInFilters, { filtersData: (_c = (_b = transferInDataFromRedux === null || transferInDataFromRedux === void 0 ? void 0 : transferInDataFromRedux.transferInData) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c[0], handleApplyCallback: function (item) {
                    var _a, _b;
                    getOrderbookTransferInTableData({
                        orderstatusId: ((_b = (_a = item === null || item === void 0 ? void 0 : item.orderBookStatus) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.value; })) === null || _b === void 0 ? void 0 : _b.join(",")) || "",
                    });
                    mutualFunOrderbookDi.mutualFundOrderBook.updateTransferInFilters({ orderBookStatus: item === null || item === void 0 ? void 0 : item.orderBookStatus });
                    setIsShowFilterPopup(false);
                }, handleCancelCallback: function () {
                    setIsShowFilterPopup(false);
                }, handleClearAllCallback: function () {
                    getOrderbookTransferInTableData({
                        orderstatusId: "",
                    });
                    mutualFunOrderbookDi.mutualFundOrderBook.updateTransferInFilters({ orderBookStatus: [] });
                    setIsShowFilterPopup(false);
                }, activeFilter: transferInDataFromRedux === null || transferInDataFromRedux === void 0 ? void 0 : transferInDataFromRedux.appliedFilters })) : (React.createElement(SummaryFilters, { filtersData: currentSelectedMutualFundTransactionsTab ===
                    EMutualFundOrderTabs.ALL_TRANSACTIONS
                    ? allTransactionsFilters
                    : SIP_STP_SWP_Filters, handleFilterChangeCallback: handleUpdateSummaryFilters, handleApplyCallback: handleApplyFilters, handleCancelCallback: handleCancelFilters, handleClearAllCallback: handleClearAllFilters, handleUpdateMandateFilterData: function (data) {
                    return handleUpdateMandateFilterData(__assign(__assign({}, mandatesFilters), { filteredData: data }));
                }, handleApplyMandateFilters: currentSelectedMutualFundTransactionsTab ===
                    EMutualFundOrderTabs.MANDATES
                    ? handleApplyMandateFilters
                    : null, mandateFilterData: mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData, currentSelectedTransactionTab: currentSelectedMutualFundTransactionsTab, allTransactionsDataFromRedux: (_d = metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.allTransactionsData) === null || _d === void 0 ? void 0 : _d.data, SIP_SWP_STP_DataFromRedux: (_e = metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.SIP_STP_SWP_TransactionsData) === null || _e === void 0 ? void 0 : _e.data, allTransactionsFiltersLoader: metaAllTransactionDataFromRedux === null || metaAllTransactionDataFromRedux === void 0 ? void 0 : metaAllTransactionDataFromRedux.mutualFundAllTransactionsTableShimmer, SIP_STP_SWP_FiltersLoader: metaSIP_STP_SWP_DataFromRedux === null || metaSIP_STP_SWP_DataFromRedux === void 0 ? void 0 : metaSIP_STP_SWP_DataFromRedux.mutualFundSIP_STP_SWP_TransactionsTableShimmer, clientNamesFilterDisplayData: commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM, clientNamesFiltersLoader: commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientLoader })), filterLabels: summaryFilterLabels, removeFilterThroughLabels: currentSelectedMutualFundTransactionsTab ===
                EMutualFundOrderTabs.MANDATES
                ? handleRemoveMandateFiltersThroughLabels
                : handleRemoveSummaryFilterThroughLabels })),
        React.createElement(MutualFundOrders, null),
        React.createElement(ProductOrderBook, { subCategoryId: Number(ESubProductIds.PMS) }),
        React.createElement(ProductOrderBook, { subCategoryId: Number(ESubProductIds.AIF) }),
        isOtcAccessible && (React.createElement(OtcProductOrder, { subCategoryId: Number(ESubProductIds.StructuredProducts), isMultiple: true }))));
};
export default ManagePortfolio;
